(function () {
  window.toggleWishlist = function (event, btn) {
    event.preventDefault();
    event.stopPropagation();
    const productId = btn.getAttribute('data-product-id');
    const variantId = btn.getAttribute('data-variant-id');
    if (!productId && !variantId) return;

    let wishlist = [];
    try {
      const stored = localStorage.getItem('wishlist');
      if (stored) {
        const parsed = JSON.parse(stored);
        wishlist = parsed.items || [];
      }
    } catch (e) { }

    const existingIndex = wishlist.findIndex(item => 
      (productId && String(item.product_id) === String(productId)) || 
      (variantId && item.variant_id && String(item.variant_id) === String(variantId))
    );
    
    if (existingIndex > -1) {
      wishlist.splice(existingIndex, 1);
      btn.classList.remove('active');
    } else {
      wishlist.push({ product_id: productId, variant_id: variantId });
      btn.classList.add('active');
    }

    localStorage.setItem('wishlist', JSON.stringify({ items: wishlist }));
    window.dispatchEvent(new CustomEvent('wishlist:updated'));
  };

  function updateAllWishlistButtons() {
    let wishlist = [];
    try {
      const stored = localStorage.getItem('wishlist');
      if (stored) {
        wishlist = JSON.parse(stored).items || [];
      }
    } catch (e) { }

    document.querySelectorAll('.wishlist-btn').forEach(btn => {
      const productId = btn.getAttribute('data-product-id');
      const variantId = btn.getAttribute('data-variant-id');
      
      const isActive = wishlist.some(item => 
        (productId && item.product_id && String(item.product_id) === String(productId)) || 
        (variantId && item.variant_id && String(item.variant_id) === String(variantId))
      );
      
      if (isActive) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  }

  function updateWishlistCount() {
    let count = 0;
    try {
      const stored = localStorage.getItem('wishlist');
      if (stored) {
        const parsed = JSON.parse(stored);
        count = (parsed.items || []).length;
      }
    } catch (e) { }

    const bubble = document.querySelector('.wishlist-count-bubble');
    const countSpan = document.querySelector('.wishlist-count');
    if (bubble && countSpan) {
      countSpan.textContent = count;
      bubble.style.display = count > 0 ? 'flex' : 'none';
    }
  }

  window.addEventListener('wishlist:updated', () => {
    updateWishlistCount();
    updateAllWishlistButtons();
  });

  function runGlobalInit() {
    updateAllWishlistButtons();
    updateWishlistCount();
  }

  if (document.readyState === "loading") {
    window.addEventListener('DOMContentLoaded', runGlobalInit);
  } else {
    runGlobalInit();
  }
})();
